<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-12 card" style="margin-left: 10px">
        <div style="margin: 0 20px 20px 20px">
          <ul style="color: #000">
           
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                  자동연장주문 관리
              </h5>
              <query-grid :config="config" ref="qg">
                <template #items="props">
                  <tr 
                    v-for="article in props.records"
                    v-bind:key="article.num"
                    style="height:50px"
                  >
                  <td scope="col" style="text-align: center; width:5%;">{{ article.num }}</td>                   
                  <td scope="col" style="text-align: center; width:10%;">{{ article.sch_name=='auto_sms'?'자동연장시스템':'기타' }}</td>                   
                  <td scope="col" style="text-align: center; width:18%;">{{ article.server_ip }}</td>                   
                  <td scope="col" style="text-align: center; width:14%;">{{ article.dt }}</td>                   
                  <td scope="col" style="text-align: center; width:15%;">{{ article.chk }}</td>                   
                  <td scope="col" style="text-align: center; width:13%;">{{ article.execution_cnt }}</td>                   
                  <td scope="col" style="text-align: center; width:15%;">{{ article.last_execution_date }}</td>  
                  <td scope="col" style="text-align: center; width:10%;">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="update(article.dt)"
                      v-if="article.chk =='미완료'"
                    >
                      재진행
                    </button> 
                 </td>
                  </tr>
                </template>
              </query-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid_sub.vue";
import Business from "../components/Business";
export default {
  components: {
    QueryGrid,
    Business,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    firstselected: "1",
    subselected: "",
    sublists: [],
    volselected: "",
    vollists: [],
    config: {
      name: "통계관리 매출",
      req_endpoint: "/subscriptions_autoLog",
      default_limit: 20,
      search_fields: [
      {
          id: "date_filter",
          name: "작업일자검색",
          type: "date"            
        },
      ],
      columns: [
      {
          id: "id",
          name: "번호",
          excel_print: (v) => {
            return v.num;
          },
        },
        {
          id: "pname",
          name: "작업명",
          excel_print: (v) => {
            return v.sch_name;
          },
        },
        {
          id: "pname",
          name: "서버IP",
          excel_print: (v) => {
            return v.server_ip;
          },
        },
        {
          id: "pyear",
          name: "날짜",
          excel_print: (v) => {
            return v.dt;
          },
        },
        {
          id: "pdateFormat",
          name: "작업여부",
          excel_print: (v) => {
            return v.chk;
          },
        },
        {
          id: "execution_cnt",
          name: "작업실행갯수",
          excel_print: (v) => {
            return v.execution_cnt;
          },
        },
        {
          id: "pdateFormat",
          name: "작업일시",
          excel_print: (v) => {
            return v.last_execution_date;
          },
        }, {
          id: "action",
          name: "관리"
        },  
        
      ],
    },
  }),
  methods: {
    update(date) {
      // approve 쪽에서 자동으로 바꿈
    // console.log("date:"+date);
    //return;
      axios
        .post("/autoUpdate/" + date)
        .then((response) => {
          //console.log(response.data.sql);
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "작업실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: " 처리완료되었습니다. 개수 ("+response.data.cnt+")" ,
                    
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );           
            this.$refs.qg.search();
          }
        });


      


    },
   
  },
  mounted() {
    //this.loadBoard()
    //this.filter_values['cate_filter_sub'] = '2025';
    //console.log(this.filter_values[cate_filter_sub] );
    axios.get("/subscriptions_autoLog").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
};
</script>
